import { Banner, Text } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import type { Release } from "../helpers/releases"

const ReleaseBanner = ({
  release,
  onDismiss,
  onShowConnection,
}: {
  release: Release
  onDismiss: () => void
  onShowConnection?: () => void
}) => {
  const { t, i18n } = useTranslation(["home"])
  const [year, month, day] = release.date.split("-").map(Number)
  const releasedOn = new Intl.DateTimeFormat(i18n.language, {
    dateStyle: "long",
  }).format(new Date(year, month - 1, day))
  const action =
    release.cta === "connection" && onShowConnection
      ? {
          content: t(`home:release.${release.key}.cta`),
          onAction: onShowConnection,
        }
      : undefined

  return (
    <Banner
      tone="info"
      title={t(`home:release.${release.key}.title`)}
      action={action}
      onDismiss={onDismiss}
    >
      <p>{t(`home:release.${release.key}.body`)}</p>
      <Text as="p" tone="subdued">
        {t("home:release.released", { date: releasedOn })}
      </Text>
    </Banner>
  )
}

export default ReleaseBanner
